import { componentRoutes } from "./componentRoutes";
import TestLayout from "../pages/layouts/test_layout";
import Dashboard from "../pages/admin/dashboard";
import Blog from "../pages/admin/blog";
import AddBlog from "../pages/admin/add_blog";
import EditBlog from "../pages/admin/edit_blog";
import ViewBlog from "../pages/admin/view_blog";
import Login from "../pages/auth/login";
import AuthLayout from "../pages/layouts/auth_layout";
import BlankLayout from "../pages/layouts/blank_layout";
import Pages from "../pages";
import ContactUs from "../pages/admin/contact_us";
import Events from "../pages/admin/Events";
import MetaInfo from "../pages/admin/meta_info";
import AddMetaInfo from "../pages/admin/add_meta_info";
import AddFaq from "../pages/admin/add_faq";
import Faq from "../pages/admin/faq";
import GenerateGotsCertificate from "../pages/admin/gots_certificate";
import News_letter from "../pages/admin/news_letter";
import NewsList from "../pages/admin/NewsList";
import AddNews from "../pages/admin/Add_news";
import EditNews from "../pages/modals/EditNews";
import Loglist from "../pages/admin/LogList";
import UserList from "../pages/admin/UserList";
import AddUserList from "../pages/admin/AddUserList";
import EditUserList from "../pages/admin/EditUserList";
// import News_letter from "../pages/admin/News_letter";

const adminRoutes = [
    {
        path: componentRoutes.adminDashboard,
        component: Dashboard,
        layout: TestLayout
    },
    {
        path: componentRoutes.blog,
        component: Blog,
        layout: TestLayout
    },
    {
        path: componentRoutes.addBlog,
        component: AddBlog,
        layout: TestLayout
    },
    {
        path: componentRoutes.editBlog,
        component: EditBlog,
        layout: TestLayout
    },
    {
        path: componentRoutes.viewBlog,
        component: ViewBlog,
        layout: TestLayout
    },
    {
        path: componentRoutes.events,
        component: Events,
        layout: TestLayout
    },
    {
        path: componentRoutes.contactUs,
        component: ContactUs,
        layout: TestLayout
    },
    {
        path: componentRoutes.metaInfo,
        component: MetaInfo,
        layout: TestLayout
    },
    {
        path: componentRoutes.addMetaInfo,
        component: AddMetaInfo,
        layout: TestLayout
    },
    {
        path: componentRoutes.userList,
        component: UserList,
        layout: TestLayout
    },
    {
        path: componentRoutes.addUser,
        component: AddUserList,
        layout: TestLayout
    },
    {
        path: componentRoutes.editUser,
        component: EditUserList,
        layout: TestLayout
    },
    {
        path: componentRoutes.addFaq,
        component: AddFaq,
        layout: TestLayout
    },
    {
        path: componentRoutes.faq,
        component: Faq,
        layout: TestLayout
    },
    {
        path: componentRoutes.newsletters,
        component: News_letter,
        layout: TestLayout
    },
    {
        path: componentRoutes.newsList,
        component: NewsList,
        layout: TestLayout
    },
    {
        path: componentRoutes.addNews,
        component: AddNews,
        layout: TestLayout
    },
    {
        path: componentRoutes.editNews,
        component: EditNews,
        layout: TestLayout
    },
    {
        path: componentRoutes.gotsCertificate,
        component: GenerateGotsCertificate,
        layout: TestLayout
    },
    {
        path: componentRoutes.logs_list,
        component: Loglist,
        layout: TestLayout
    },

];

const rootRoutes = [
    {
        path: componentRoutes.root,
        component: Pages,
        layout: BlankLayout
    },
    {
        path: componentRoutes.login,
        component: Login,
        layout: AuthLayout
    },
]

export const pageRoutes = [
    ...rootRoutes,
    ...adminRoutes
];